"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Boolean
 */
var bool = function bool() {
  var _this = this;

  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  _classCallCheck(this, bool);

  _defineProperty(this, "toBuffer", function () {
    var buf = Buffer.allocUnsafe(_this.space);
    buf.writeUIntLE(_this.value ? 1 : 0, 0, _this.space);
    return buf;
  });

  _defineProperty(this, "fromBuffer", function (buf) {
    if (!Buffer.isBuffer(buf)) throw new Error('Invalid buffer');
    _this.value = Boolean(buf.readUIntLE(0, _this.space));
    return _this.value;
  });

  this.value = value;
  this.type = 'bool';
  this.space = 1;
};

module.exports = {
  bool: bool
};